import { useState, useEffect } from 'react';

import { api } from 'api';
import { notify } from 'libs/common';
import { ErrorMsg, Select2 } from 'libs/form';
import { Popup2, Button, themes, ButtonContainer, SimpleInput, SimpleSelect } from 'libs/ui';
import { Content, NewTicketHeader, Line2 } from './promise-contract.styled';

export const PromiseContract = (props) => {
  const { id, close } = props;

  const [error, setError] = useState(false);
  const [working, setWorking] = useState(false);
  const [validated, setValidated] = useState(false);
  const [contract, setContract] = useState();
  const [data, setData] = useState({ fio: '', n: '', status: 'notpayed' });
  const [status, setStatus] = useState('notpayed');

  useEffect(() => {
    const getContract = () => {
      api
        .call('promise_pay.view', { stay_id: id }, 'NetworkManager')
        .then((data) => {
          setContract(data);
          setData({
            fio: data ? data.client_name : '',
            n: data ? data.contract_number : '',
            status: data ? (data.is_payed ? 'payed' : 'notpayed') : 'notpayed',
          });
        })
        .catch((error) => {
          notify('Ошибка получения договора', error);
        });
    };
    getContract();
  }, []);

  const changeStatus = (event) => {
    // console.log("status", status);
    const status = event.target.value;
    setStatus(status);
    const out = { ...data };
    out.status = status;
    const validated = validate(out);
    setData(out);
    setValidated(validated);
  };

  /**
   * set value
   * @param {*} e
   */
  const setValue = (e) => {
    const out = { ...data };
    out[e.target.name] = e.target.value;
    // console.log('e.target.name', e.target.name);
    const validated = validate(out);
    setData(out);
    setValidated(validated);
  };

  /**
   * validate
   * @param {*} data
   * @returns
   */
  const validate = (data) => {
    let out = true;
    if (data.fio === '') {
      out = false;
    }
    if (data.n === '') {
      out = false;
    }
    return out;
  };

  /**
   * save
   */
  const save = () => {
    const out = {
      stay_id: id,
      client_name: data.fio,
      contract_number: data.n,
      is_payed: data.status === 'payed',
    };
    api
      .call('promise_pay.edit', out, 'NetworkManager')
      .then(() => {
        close();
      })
      .catch((error) => {
        notify('Ошибка изменения договора', error);
      });
  };

  if (contract === undefined) {
    return null;
  }

  const statuses = [
    { value: 'payed', name: 'Оплачено' },
    { value: 'notpayed', name: 'Не оплачено' },
  ];

  return (
    <>
      <Popup2 w={515}>
        <Content>
          <NewTicketHeader>Договор паркирования</NewTicketHeader>
          {error && <ErrorMsg error="Ошибка" />}

          <form>
            <Line2>
              <span className="l">Ф.И.О.</span>
              <SimpleInput type="text" name="fio" value={data.fio} onChange={setValue} />
            </Line2>
            <Line2>
              <span className="l">№ договора паркирования</span>
              <SimpleInput type="text" name="n" value={data.n} onChange={setValue} />
            </Line2>
            <Line2>
              <span className="l">Статус оплаты</span>
              <Select2 name="status" value={status} onChange={changeStatus} items={statuses} />
            </Line2>
          </form>
          <ButtonContainer space="20px" justifyContent={'flex-start'} style={{ marginTop: '40px' }}>
            <Button disabled={working} fontSize="16px" onClick={close}>
              Отменить
            </Button>
            <Button disabled={working || !validated} theme={themes.blue} fontSize="16px" onClick={save}>
              Сохранить
            </Button>
          </ButtonContainer>
        </Content>
      </Popup2>
    </>
  );
};
